var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30564",
    "data-name": "Group 30564",
    transform: "translate(-933 -482)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2732",
    "data-name": "Ellipse 2732",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(933 482)",
    fill: "#ff7070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143160",
    "data-name": "Path 143160",
    d: "M1.049-9.152H5.807V-7.1h-11.7V-9.152H1.049Z",
    transform: "translate(947 504)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBusiness);
export default __webpack_public_path__ + "static/media/DeleteBusiness.a361671f8afa11b7690d7910fbd95010.svg";
export { ForwardRef as ReactComponent };